import { ProcessType } from "@/types";

/** Reads the `process` a FLOW task context carries, for routing and logging. */
export const processTypeFromContext = (
	context: unknown
): ProcessType | undefined => {
	if (
		context &&
		typeof context === "object" &&
		"process" in context &&
		typeof (context as { process: unknown }).process === "string"
	) {
		return (context as { process: ProcessType }).process;
	}
	return undefined;
};
